
import Vue from 'vue';

export default Vue.extend({
  name: 'PcPageLoading',
  props: {
    text: {
      type: String,
      default: '加载中...',
    },
  },
});
